import { useState } from "react"
import fetchData from "../../../shared/fetchData"
import ContentForm from "../../UI/ContentForm/ContentForm"
import DatePicker from "../../UI/DatePicker/DatePicker"
import TimePicker from "../../UI/TimePicker/TimePicker"
import Button from "../../UI/Button/Button"
import { useEffect } from "react"


const ChangeOrder = (props) => {

    const [oldStartDate, setOldStartDate] = useState('')
    const [oldEndDate, setOldEndDate] = useState('')
    const [oldStartTime, setOldStartTime] = useState('')
    const [oldEndTime, setOldEndTime] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [invalidDate, setInvalidDate] = useState(false)
    const [invalidTime, setInvalidTime] = useState(false)
    useEffect(() => {
        setOldStartDate(props?.order?.startDate)
        setOldEndDate(props?.order?.endDate)
        setOldStartTime(props?.order?.startTime)
        setOldEndTime(props?.order?.startTime)
    }, [])

    const changeStartDate = (unix, formatted) => {
        setStartDate(formatted)
    }
    const changeEndDate = (unix, formatted) => {
        setEndDate(formatted)
    }
    const changeStartTime = (value) => {
        setStartTime(value)
    }

    const changeEndTime = (value) => {
        setEndTime(value)
    }
    const changeOrderSubmit = (event) => {
        let valid = true
        if (startTime == null || startTime == '' || startTime == '0:0') {
            valid = false
            setInvalidTime(true)
        }
        if (endTime == null || endTime == '' || endTime == '0:0') {
            valid = false
            setInvalidTime(true)
        }
        if (startDate == null || startDate == '') {
            valid = false
            setInvalidDate(true)
        }
        if (endDate == null || endDate == '') {
            valid = false
            setInvalidDate(true)
        }
        var info = {
            "orderId": props.order?.id,
            "startDate": startDate,
            "startTime": startTime,
            "endDate": endDate,
            "endTime": endTime,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/changeOrder'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    props.closeAndReload();
                }
            })
            .catch(error => console.log(error))
    }

    return (
        <div className='row justify-content-center'>
            <div className='rent-ord-cntnr'>
                <ContentForm headetText='اطلاعات سفارش'>
                    <DatePicker className="disable-div" change={() => console.Console.og()} value={oldStartDate} placeHolder="تاریخ شروع" col="6" />
                    <TimePicker
                        onChange={() => console.Console.og()}
                        value={oldStartTime}
                        placeHolder="ساعت شروع"
                        className="disable-div"
                        col="6"
                    />
                    <DatePicker className="disable-div" change={() => console.Console.og()} value={oldEndDate} placeHolder="تاریخ پایان" col="6" />
                    <TimePicker
                        onChange={() => console.Console.og()}
                        value={oldEndTime}
                        placeHolder="ساعت پایان"
                        className="disable-div"
                        col="6"
                    />
                    <DatePicker className={invalidDate && (startDate == null || startDate == '') ? 'invalid-date' : ''} change={changeStartDate} value={startDate} placeHolder="تاریخ شروع جدید" col="6" />
                    <TimePicker
                        onChange={changeStartTime}
                        value={startTime}
                        placeHolder="ساعت شروع جدید"
                        className={invalidTime && (startTime == null || startTime == '' || startTime == '0:0') ? 'invalid-time' : ''}
                        col="6"
                    />
                    <DatePicker className={invalidDate && (endDate == null || endDate == '') ? 'invalid-date' : ''} change={changeEndDate} value={endDate} placeHolder="تاریخ پایان جدید" col="6" />
                    <TimePicker
                        onChange={changeEndTime}
                        value={endTime}
                        placeHolder="ساعت پایان جدید"
                        className={invalidTime && (endTime == null || endTime == '' || endTime == '0:0') ? 'invalid-time' : ''}
                        col="6"
                    />
                    <div className='row justify-content-center w-100 mt-3'>
                        <div className='col-6 text-center'>
                            <Button btnType="General" clicked={(event) => props.handleClose()} >برگشت</Button>
                        </div>
                        <div className='col-6 text-center'>
                            <Button btnType="Success" clicked={changeOrderSubmit} >ثبت</Button>
                        </div>
                    </div>
                </ContentForm>
            </div>
        </div>
    )
}

export default ChangeOrder;